/* helpers */
import R2Dom from "../helpers/R2Dom";

/* import methods */
import "../methods/example.js";

/* init */
R2Dom.Init();
console.warn("src/pages/home.js Successfuly Loaded !");